module.exports = __webpack_public_path__ + "static/img/worth1.120760f1.png";